import { Component, OnInit } from '@angular/core';
import { LandingPageService } from './service/landing-page.service';
import { TabI } from 'src/app/shared/models/navigation-tabI';
import { LANDING_PAGE_TABS_LIST } from './assets/landingPageTabsList';
import { AuthenticationService } from '../login/service/authentication.service';
import {ButtonConfig, IconButtonConfig, ModalService, PageActionService, UtilityService} from '@collab/comp-library';
import { ContactUsService } from 'src/app/shared/component/contact-us/service/contact-us.service';
import { ModalConfig } from '@collab/comp-library/ui/modal/modal.config';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/shared/services/auth.service';


@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {
    private version=environment.gitCommitRef;
    private time=environment.gitCommitTimestamp;
    public translate = 'translateX';
    public interval = 8000;
    public transition = '.7s'
    public showPagePermission = 'Landing Page';
    public userDetails: any;
    public item: any;
    public picture:any;
    public versionui:any;
    public timestamp:any;
    public userRelatedProducts: any;
    public tabs: TabI[] = [];
    public productDetails: Array<any> =[];
    public showNotifications = true;
    public showIconLength = 4;
    public currentImage = 0;
    public isClient = false;
    public indicator=true;
    public footer=false;
    public reelVideoIconButtonConfig: IconButtonConfig = {
        buttonSize: 'large',
        iconURL: 'icon-Play',
        imageUrl: '',
        text: '',
        linkURL: '',
        outline: true,
  };
    public versionModalConfig: ModalConfig = {
        id: 'modal',
		type: 'dialog',
		title: "Ascendion AVA Version",
		closeButton: false,
		primaryButtonConfig: {
			text: "Ok",
			buttonType: "primary",
			buttonSize: "medium",
			imageUrl: "",
			linkURL: "",
		  },
    };

    public platformMainMenu = [
        {
            url: 'https://dev.avateam.io/help/#t=AVA%2FAbout_AVA.htm',
            value: 'About',
        },
        {
            url: 'https://dev.avateam.io/help/#t=HELP%2FHELP.htm',
            value: 'Help',
        },
        {
            url: 'https://en.wikipedia.org/wiki/Contact',
            value: 'Contact',
        },
    ];

    public showAllStudioBtnConfig: ButtonConfig = {
        text: 'Show All',
        buttonType: 'secondary',
        iconURL: '',
        imageUrl: '',
        linkURL: '',
    };

    public topCarousel=[
        {
            src:'../../../assets/ava_top_carousel.png'
        },
        {
            src:'../../../assets/ava_top_carousel.png'
        },
        {
            src:'../../../assets/ava_top_carousel.png'
        },
    ]
    constructor(private landingPageService: LandingPageService, 
        private modalService:ModalService,
        private authenticationService: AuthenticationService,
        private utilityService: UtilityService,
        private contactUsService: ContactUsService,
        public pageActionService: PageActionService ,
        public authService: AuthService,) {}

    public ngOnInit(): void {
        // if (! this.pageActionService.pageActions) {
        //     this.pageActionService.getPageActions().subscribe((response:any) => {
        //         this.pageActionService.pageActions = response.pageActions;
        //         this.tabs = LANDING_PAGE_TABS_LIST;
        //     });
        // }
        this.tabs = LANDING_PAGE_TABS_LIST;
        //this.getLandingPageUserDetails();
        this.getProductDetailsList();
        if (!this.landingPageService.productsList) {
            this.getProductDetailsList();
        } 
        this.versionui=this.version;
        this.timestamp=this.time;
        
    }

    /**
     * this method will make API call to get the landingpageUserDetails
     * @returns {void}
     * @memberof LandingPageComponent
     */
    public getLandingPageUserDetails(): void {
        this.landingPageService.getLandingPageUserDetails().subscribe((response) => {
            this.userDetails = response && response.userDetails;
            this.userRelatedProducts = response && response.products;
            this.utilityService.broadcastUserProfile(this.userDetails);
        });
    }

    /**
     * this will get the details of all the products
     * @returns {void}
     * @memberof LandingPageComponent
     */
    public getProductDetailsList(): void {
        this.landingPageService.getProductDetailsList().subscribe((response) => {
            this.productDetails = response.length > 0 && response;
            this.landingPageService.setProductsList(this.productDetails);
        });
    }

    public goTo(url: string, _target?: string) {
        window.open(url, '_blank');
    }

    public onShowAllClick(): void {
        this.showNotifications = false;
        this.showIconLength = this.userRelatedProducts.subscribedList.length;
    }
    public onVersionClick(){
        this.modalService.open('Version');
    }
     public onVersionSubmit(){
        this.modalService.close('Version')
     }

    public logout() {
       // this.authenticationService.logOut(false); // pass the ennvironment variable from hete
       this.authService.logout();
    }

    public onContactUsClick() {
        this.contactUsService.isContactUsShow = true;
    }
    public onNotification() {
        if (this.userRelatedProducts.subscribedList.length < 4) {
        this.showNotifications = true;
    }
    
  }
  
}
